export enum NoResponsesVariationType {
  Default = 'Default',
  NoInitialOrInProgress = 'NoInitialOrInProgress',
  NoInitialSomeInProgress = 'NoInitialSomeInProgress',
  SomeInitialNoInProgress = 'SomeInitialNoInProgress',
  SomeInitialOrInProgressNoFinal = 'SomeInitialOrInProgressNoFinal',
  FlyingCardsTooHeavy = 'FlyingCardsTooHeavy',
  FlyingCardsABitHeavy = 'FlyingCardsABitHeavy',
  SocialCXNoReviews = 'SocialCX-NoReviews',
  SocialCXNoUnread = 'SocialCX-NoUnread',
  SocialCXNoPendingReplies = 'SocialCX-NoPendingReplies',
  SocialCXRefreshingReviews = 'SocialCX-RefreshingReviews',
  ReadyToDownloadExport = 'ReadyToDownloadExport',
  DownloadExportExpired = 'DownloadExportExpired',
}
